export enum HighlightsMarqueePage {
    Lobby = 'Lobby',
    SportsLobby = 'SportsLobby',
    BetbuilderCarousel = 'BetbuilderCarousel',
    EventDetails = 'EventDetails',
    Competition = 'Competition',
    TeamsPage = 'TeamsPage',
    TopScreen = 'TopScreen',
}
